import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget, FiClock, FiUsers, FiShield, FiArrowRight } = FiIcons;

const StartPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Karriereplanungstest</h1>
          <Link 
            to="/impressum" 
            className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
          >
            Impressum
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto text-center"
        >
          <div className="mb-8">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiTarget} className="w-10 h-10 text-blue-600" />
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Entdecken Sie Ihre Karriereziele
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Dieser wissenschaftlich fundierte Test hilft Ihnen dabei, 
              Ihre beruflichen Ziele zu reflektieren, Ihre Stärken zu erkennen 
              und Entwicklungsbereiche zu identifizieren.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-10">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="bg-white p-6 rounded-lg shadow-sm border"
            >
              <SafeIcon icon={FiTarget} className="w-8 h-8 text-blue-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Was wird gemessen?</h3>
              <p className="text-gray-600 text-sm">
                Karriereziele, berufliche Motivation, Planungsverhalten und Anpassungsfähigkeit
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="bg-white p-6 rounded-lg shadow-sm border"
            >
              <SafeIcon icon={FiClock} className="w-8 h-8 text-green-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Dauer & Umfang</h3>
              <p className="text-gray-600 text-sm">
                9 Fragen • 5-10 Minuten • Sofortige Auswertung
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
              className="bg-white p-6 rounded-lg shadow-sm border"
            >
              <SafeIcon icon={FiUsers} className="w-8 h-8 text-purple-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Für wen geeignet?</h3>
              <p className="text-gray-600 text-sm">
                Berufstätige, Studierende und alle, die ihre Karriere reflektieren möchten
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5, duration: 0.5 }}
              className="bg-white p-6 rounded-lg shadow-sm border"
            >
              <SafeIcon icon={FiShield} className="w-8 h-8 text-orange-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Datenschutz</h3>
              <p className="text-gray-600 text-sm">
                Ihre Antworten bleiben vollständig anonym und werden nicht gespeichert
              </p>
            </motion.div>
          </div>

          {/* Start Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <Link
              to="/test"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Test jetzt starten
              <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </Link>
          </motion.div>

          {/* Disclaimer */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
            className="mt-8 text-sm text-gray-500 max-w-lg mx-auto"
          >
            Dieser Test dient der Selbstreflexion und ersetzt keine professionelle Karriereberatung. 
            Die Ergebnisse sind als Orientierungshilfe zu verstehen.
          </motion.p>
        </motion.div>
      </main>
    </div>
  );
};

export default StartPage;